import cn from 'classnames';
import {
  DropdownIndicatorProps,
  components as ReactSelectComponents,
  GroupBase,
  SelectComponentsConfig,
} from 'react-select';

import styles from '../select.module.scss';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  ownProps: DropdownIndicatorProps<SOption, IsMulti, Group>,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
}

const DropdownIndicator = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  ownProps,
  components = {},
}: IProps<SOption, IsMulti, Group>) => {
  if (components?.DropdownIndicator) {
    const { DropdownIndicator: DropdownIndicatorComponent } = components;

    return <DropdownIndicatorComponent { ...ownProps } />;
  }

  return (
    <ReactSelectComponents.DropdownIndicator
      { ...ownProps }
      className={ cn(ownProps.className, styles.dropdownIndicator) }
    />
  );
};

export default DropdownIndicator;
